import React from 'react';
import { usePageTracking } from '../hooks/usePageTracking';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone, Mail, MapPin, Clock, Instagram } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import IntakeForm from '../components/IntakeForm';
import { firmInfo } from '../data/mock';

const ContactPage = () => {
  usePageTracking("Contact", { category: "contact" });
  return (
    <div className="min-h-screen bg-[#1a1c1b]">
      <Header />
      
      <main className="pt-24 pb-16">
        {/* Back Link */}
        <div className="max-w-[87.5rem] mx-auto px-5 md:px-10 mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#888680] hover:text-[#d9fb06] transition-colors text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>

        {/* Hero Section */}
        <section className="max-w-[87.5rem] mx-auto px-5 md:px-10 mb-12">
          <div className="max-w-4xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#d9fb06] mb-6 tracking-tight">
              Contact Us
            </h1>
            <p className="text-lg md:text-xl text-[#888680] leading-relaxed">
              Ready to dispute your account suspension? Fill out the form below or reach out directly.
            </p>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="max-w-[87.5rem] mx-auto px-5 md:px-10 mb-12">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <a 
              href={`tel:${firmInfo.phone}`}
              className="bg-[#252825] border border-[#3f4816] rounded-xl p-6 hover:border-[#d9fb06]/50 transition-colors group"
            >
              <Phone className="w-6 h-6 text-[#d9fb06] mb-3 group-hover:scale-110 transition-transform" />
              <p className="text-[#888680] text-xs uppercase tracking-wide mb-1">Phone</p>
              <p className="text-[#d9fb06] font-medium">{firmInfo.phone}</p>
            </a>

            <a 
              href={`mailto:${firmInfo.email}`}
              className="bg-[#252825] border border-[#3f4816] rounded-xl p-6 hover:border-[#d9fb06]/50 transition-colors group"
            >
              <Mail className="w-6 h-6 text-[#d9fb06] mb-3 group-hover:scale-110 transition-transform" />
              <p className="text-[#888680] text-xs uppercase tracking-wide mb-1">Email</p>
              <p className="text-[#d9fb06] font-medium text-sm">{firmInfo.email}</p>
            </a>

            <a 
              href="https://instagram.com/socialdisputeco"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#252825] border border-[#3f4816] rounded-xl p-6 hover:border-[#d9fb06]/50 transition-colors group"
            >
              <Instagram className="w-6 h-6 text-[#d9fb06] mb-3 group-hover:scale-110 transition-transform" />
              <p className="text-[#888680] text-xs uppercase tracking-wide mb-1">Instagram</p>
              <p className="text-[#d9fb06] font-medium">{firmInfo.instagram}</p>
            </a>

            <div className="bg-[#252825] border border-[#3f4816] rounded-xl p-6">
              <Clock className="w-6 h-6 text-[#d9fb06] mb-3" />
              <p className="text-[#888680] text-xs uppercase tracking-wide mb-1">Response Time</p>
              <p className="text-[#d9fb06] font-medium">Within 24 hours</p>
            </div>

            <div className="bg-[#252825] border border-[#3f4816] rounded-xl p-6">
              <MapPin className="w-6 h-6 text-[#d9fb06] mb-3" />
              <p className="text-[#888680] text-xs uppercase tracking-wide mb-1">Location</p>
              <p className="text-[#d9fb06] font-medium">Honolulu, Hawaii, USA</p>
            </div>
          </div>
        </section>

        {/* Intake Form */}
        <section className="max-w-[87.5rem] mx-auto px-5 md:px-10">
          <IntakeForm />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
